export default __webpack_public_path__ + "static/media/lose@2x.0b23460c.png";